<template>
        <div>
             <div class='container fluid'>
                 <div class="row">
                     <div class='col-12'>
                    <transition name="fade">
                        <div v-if="performingRequest" class="loading">
                            <p>Sending Message...</p>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-if="showMessageSent" class="loading">
                            <p>Message Sent</p>
                        </div>
                    </transition>
                     </div>
                 </div>
                    <div class="row style='margin-bottom:10px;' ">
                        <div class='col-12'>
                            <div v-for="(message) in arrayDefaultMessages" :key='message' style='margin-bottom:10px;' >
                                <b-button  size="sm" variant="outline-primary" @click="setMessage(message)">{{message}}</b-button>
                            </div>
                        </div>
                    </div>

                  <!-- Using components -->
                  <div>
                    <b-input-group>
                        <b-form-textarea v-model.trim="theMessage" :placeholder="defaultMessage"  ></b-form-textarea>
                        <b-input-group-append>
                        <b-button variant="info" :disabled='!theMessage' @click="sendMessage()">Send Message</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>

            </div>
        </div>
</template>

<script>

/*module.exports = {
  props: ['receiverId']
}*/

import { mapState } from 'vuex'
import { currentUser, zipcodesCollection } from '../firebaseConfig'
import moment from 'moment'
const fb = require('../firebaseConfig.js')
import firebase from 'firebase/app';
import {sendChatEmail} from  './Myfunctions'
import {sendnotification} from './Myfunctions'

export default {
    props: ['receiverId', 'receiverName', 'arrayDefaultMessages', 'modalid'],

            data() {
            return {
                showSuccess: false,
                theMessage:'',
                performingRequest:false,
                showingThread:false,
                showMessageSent: false,
                defaultMessage:'Type your message'
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'isBrewer']),

        },
        methods:{
            sendMessage(){
                var threadExists = 0
                var theDocId
                var kegseekeremail = "messages_" 
                this.performingRequest=true

                //Check if there's a message
                if(!this.theMessage) {
                    this.performingRequest=false
                    return
                }

                //Create new docId by concatentating the two user IDs
                if (this.currentUser.uid<this.receiverId){
                    theDocId = this.currentUser.uid + this.receiverId
                    kegseekeremail =  kegseekeremail + this.currentUser.uid  + '_' + this.receiverId + '@orderupdates.kegseeker.com'
                } 
                else{
                    theDocId = this.receiverId + this.currentUser.uid
                    kegseekeremail =  kegseekeremail  + this.receiverId  + '_' + this.currentUser.uid + '@orderupdates.kegseeker.com'
                } 

                var min=11111111111111111; 
                var max=99999999999999999;  
                var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 

                var messageObject = {}
                
                messageObject.senderId = this.currentUser.uid
                messageObject.createdOn = new Date()
                messageObject.id = randomId
                messageObject.message = this.theMessage
                messageObject.sentBy = this.userProfile.company
                messageObject.readByReceiver = 0

                //Check if this thread already exists
                fb.messagesCollection.doc(theDocId).get().then(res => {
                    //If thread exists, just add the new message
                    if (res.data()){
                        //Update message info
                        //Reset array of people who deleted this message
                        var hiddenByUsers=[]

                        fb.messagesCollection.doc(theDocId).update({ "messageinfo.lastMessage": this.theMessage,"messageinfo.createdOn": new Date(),
                         "messageinfo.senderId": this.currentUser.uid, "messageinfo.readByReceiver": 0, 'messageinfo.hiddenByUsers':hiddenByUsers, messages: firebase.firestore.FieldValue.arrayUnion({message: messageObject})})
                        .then((response) => {
                            this.performingRequest = false
                            this.showMessageSent = true
                            setTimeout(() => { 
                                this.showMessageSent = false 
                                this.$emit('closeMessageModal', this.modalid)
                            }, 1500)
                                this.theMessage = ''
                            })
                        }

                    //if not, create new thread
                    else{
                        console.log("Thread does not exist")
                        var messageInfoObject = {}
                        messageInfoObject.hiddenByUsers=[]
                        messageInfoObject.senderId = this.currentUser.uid
                        messageInfoObject.createdOn = new Date()
                        messageInfoObject.readByReceiver = 0
                        messageInfoObject.id = randomId
                        messageInfoObject.lastMessage = this.theMessage
                        messageInfoObject.sentBy = this.userProfile.name
                        

                        if(parseInt(this.userProfile.isbrewer)==1||parseInt(this.userProfile.isbrewer)==2){
                            messageInfoObject.brewerId = this.currentUser.uid
                            messageInfoObject.pubId = this.receiverId
                            messageInfoObject.brewerName= this.userProfile.company
                            /*******************************************/
                            messageInfoObject.pubName= this.receiverName
                            /*********** NEED TO UPDATE THIS ***********/
                            /*******************************************/

                        }
                        else{
                            messageInfoObject.brewerId = this.receiverId
                            messageInfoObject.pubId = this.currentUser.uid
                            messageInfoObject.brewerName= this.receiverName
                            messageInfoObject.pubName= this.userProfile.company
                        }

                        fb.messagesCollection.doc(theDocId).set({messageinfo:messageInfoObject, messages: firebase.firestore.FieldValue.arrayUnion({message: messageObject})})
                        .then((response) => {
                            this.performingRequest = false
                            this.showMessageSent = true
                            console.log("Setting timeout")
                            setTimeout(() => { 
                                this.showMessageSent = false 
                                //Send message to close modal
                                this.$emit('closeMessageModal', this.modalid)
                            }, 1500)
                            this.theMessage = ''
                            
                        })
                        
                    }
                    //Send email
                    var subject = 'New message from ' + this.userProfile.company
                    var text = this.theMessage
                    
                    sendChatEmail(this.receiverId,subject, text, this.userProfile.company, kegseekeremail)

                    sendnotification(this.receiverId, subject)

                })
            },
            setMessage(message){
                this.theMessage = message
            },
        },
}


</script>